import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiKeysInterface } from '../../models/dashboard/configuration/api-key.model';

interface IInitialState {
  apiKeysData?: ApiKeysInterface;
}

const initialState: IInitialState = {
  apiKeysData: undefined
};

const apiKeysDataSlice = createSlice({
  name: 'apiKeysDataSlice',
  initialState,
  reducers: {
    setApiKeysData(state, action: PayloadAction<ApiKeysInterface>) {
      state.apiKeysData = action.payload;
    },
  },
});

export const apiKeysDataActions = apiKeysDataSlice.actions;
export default apiKeysDataSlice.reducer;
